import React from "react";
import { Box } from "@mui/material";

const VerticalGroup = ({
                           children,
                           color,
                           thickness = 4,
                       }: {
    children: React.ReactNode;
    color: string;
    thickness?: number;
}) => (
    <Box sx={{ display: 'flex', mb: 3 }}>
        <Box
            sx={{
                borderLeft: `${thickness}px solid ${color}`,
                borderRadius: 2,
                mr: 2,
                width: `${thickness}px`,
            }}
        />
        <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
);

export default VerticalGroup;